import MyDivider from "src/components/layout/MyDivider";
import UserAsiakasSelectorDropdown from "src/components/UserAsiakasSelectorDropdown/UserAsiakasSelectorDropdown";
import { useUserData } from "src/context/userContext";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  asiakasNimi: {
    fontSize: "3em",
    opacity: 0.8,
    lineHeight: "55px",
    fontWeight: "bold",
  },
  personNimi: {
    fontSize: "1.3em",
  },
};

export default function Koti_Header() {
  const { user } = useUserData();
  return (
    <div style={styles.root}>
      <UserAsiakasSelectorDropdown
        typographyProps={{
          sx: styles.asiakasNimi,
        }}
        dropdownIconProps={{
          sx: { fontSize: "2em" },
        }}
      />
      <MyDivider
        chipText={
          <div>
            <div style={{ lineHeight: 1 }}>{user?.personFullName}</div>
            <div style={{ fontSize: "9px", opacity: 0.7 }}>{user?.personEmail}</div>
          </div>
        }
      />
    </div>
  );
}
